import { render, staticRenderFns } from "./risk-archived-tasks.vue?vue&type=template&id=386878dc"
import script from "./risk-archived-tasks.vue?vue&type=script&lang=js"
export * from "./risk-archived-tasks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports